import { render, staticRenderFns } from "./_with_required.vue?vue&type=template&id=f28bbd62&lang=pug"
import script from "./_with_required.vue?vue&type=script&lang=js"
export * from "./_with_required.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports